import { useEffect } from 'react';

const useTitle = (titleOrFn, dependency) => {
	useEffect(() => {
		document.title = typeof titleOrFn === 'function' ? titleOrFn() : titleOrFn;
	}, [titleOrFn, dependency]);
};

export default useTitle;



// WEBPACK FOOTER //
// ./src/hooks/UseTitle.js